import * as React from 'react';
import { SiteApiKeysSetting } from './SiteApiKeysSetting';
import { SiteManagedIntegrations } from './SiteManagedIntegrations';
import { SiteWebsocketSetting } from './SiteWebsocketSetting';

export function SiteDeveloperSettings({ siteUuid }: { siteUuid: string }) {
  return (
    <>
      <SiteApiKeysSetting siteUuid={siteUuid} />
      <SiteWebsocketSetting siteUuid={siteUuid} />
      <SiteManagedIntegrations siteUuid={siteUuid} />
    </>
  );
}
